/** First path segment for shop taxonomy PLPs. */
export const SHOP_PATH_PREFIX = 'shop';

/** Reserved segment: ends taxonomy in the pathname; segments after it are ignored (legacy path filters). */
export const SHOP_FILTER_SEPARATOR = '-';

/**
 * Pim product-type attribute names for /shop taxonomy levels (single mapping for shop root).
 * Stored verbatim in `productsQuery.taxonomyAttributes`; the listings-api / facet key form
 * is `attributes.{name}`, matching entries in sort-and-facet-configurations.json.
 */
export const SHOP_TAXONOMY_ATTRIBUTE_NAMES = [
  'pim_product_type_level_1',
  'pim_product_type_level_2',
  'pim_product_type_level_3',
  'pim_product_type_level_4',
] as const;

export const taxonomyAttributeToFacetKey = (attribute: string): string => `attributes.${attribute}`;

/** Placeholder segment meaning “skip this taxonomy level”. */
export const SHOP_TAXONOMY_SKIP_SEGMENT = 'all';
